import axios from 'axios'
//import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { changeUser } from '../reducers/userReducer'

const Callback = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  /*useEffect(() => {

  }, [dispatch])*/
  axios.get('/users/getuser').then(response => {
    dispatch(changeUser(response.data))
    window.localStorage.setItem('loggedUser', JSON.stringify(response.data.id))
  })
  navigate('/login')
  return <></>
}

export default Callback
